import React from 'react';
import BinIcon from '../../images/bin_icon.png'
import PlusIcon from '../../images/+_icon.png'
import { withTranslation } from 'react-i18next';
import Dialog from '../Dialog/Dialog';
import { AdminHandler } from '../AdminHandler/AdminHandler';
import SearchBar from '../SearchBar/SearchBar';
import Checkmark from '../../images/faq_check.png'
import Pagination from '../Pagination/Pagination';
import { callIfMouseSupported, callIfTouchSupported, callIfPointerSupported } from '../General/EventSupport';

const MAX_COMPANIES_PER_PAGE = 12;

class CompanyList extends React.Component {

    getCompaniesSortTags() {
        const { t } = this.props;
        return [
            {title: t('SortTagName'),
              function:
                function(elements){
                  elements.sort(function(a, b){
                    if(a.CompanyName < b.CompanyName) { return -1; }
                    if(a.CompanyName > b.CompanyName) { return 1; }
                    return 0;
                })
              }},
            {title: t('SortTagCompaniesModelLimit'),
              function:
                function(elements){
                  elements.sort(function(a, b){
                    return b.ModelLimit - a.ModelLimit;
                  })
              }},
            {title: t('SortTagCompaniesAppAccess'),
              function:
                function(elements){
                  elements.sort(function(a, b){
                    return (a.AppAccess === b.AppAccess)? 0 : a.AppAccess? -1 : 1;
                  })
              }},
        ];
    }

    static defaultProps = {
      onUpdateCompanies: () => {},
      onUpdateUserLimit: () => {},
    };

    constructor(props) {
        super(props);

        this.state = {
          dragOver: false,
          users: [], //probably not needed
          companies: [],
          addingCompany: false,
          tempCompanyName: "",
          tempCompanyLimit: 0,
          tempUserLimit: 0,
          tempRapid: false,
          tempAppAccess: false,
          editCompanyLimit: -1,
          editCompanyUserLimit: -1,
          tempModelLimit: "",
          companiesSearchOptions: {sortTag: this.getCompaniesSortTags()[0], filterTag: null, inverted: false},
          open: true,
          headerOpen: true,
          searchedCompanies: [],
          companiesToRender: [],

          //pagination
          maxCompaniesPerPage: MAX_COMPANIES_PER_PAGE,
          companyPageIndex: 0,
          companyPagesAmount: 0
        };
    }

    componentDidMount(){
      this.getCompanies();
    }

    setEditCompanyLimit(idx, guid, newLimit =""){
      let companyIndex = this.getCompanyIndexWithGUID(guid);
      if (newLimit !== ""){
        var companies = this.state.companies;
        companies[companyIndex].ModelLimit = newLimit;
        this.setState({companies: companies});
        AdminHandler.updateCompanyLimit(guid, newLimit);
      }

      var templimit = "";
      if (this.state.companies && companyIndex >= 0){
        templimit = this.state.companies[companyIndex].ModelLimit;
      }

      this.setState({editCompanyLimit: idx, tempModelLimit: templimit});
    }

    setEditCompanyUserLimit(idx, guid, newLimit =""){
      const { t } = this.props;
      const companyIndex = this.getCompanyIndexWithGUID(guid);
      if (newLimit !== ""){
        const companyGUID = guid;
        var companies = this.state.companies;
        companies[companyIndex].UserLimit = newLimit;
        this.setState({companies: companies});
        AdminHandler.updateUserLimit(companyGUID, newLimit).then((res) => {
          this.props.onUpdateUserLimit(companyGUID);
        }).catch((err) =>{
          console.warn("User limit update failed");
          Dialog.Alert({
            title: t('LoadError'),
            description: t('UserLimitUpdateError'),
            options: [
                {label: "OK", className:""},
            ],
            panelOptions: {className: "vithrough oneButtonDialog"}
          })
        });
      }

      var templimit = "";
      if (this.state.companies && this.state.companies[companyIndex]){
        templimit = this.state.companies[companyIndex].UserLimit;
      }

      this.setState({editCompanyUserLimit: idx, tempUserLimit: templimit});
    }

    getCompanies(callback = function(){}){
        AdminHandler.getAllCompanies("asd")
        .then((res) => {
            res.data.sort((a,b) => {
                return a.CompanyName > b.CompanyName ? 1 : -1;
            });

            if(res.data){
                this.setCompaniesToRender(res.data, this.state.searchOptions, 0);
                this.setState({companies: res.data})
            }

            this.props.onUpdateCompanies(res.data);
        })
        .catch((err) =>{
            console.error(err);
        })
    }

    getCompanyIndexWithGUID(guid){
      if(!this.state.companies){
        return -1;
      }

      return this.state.companies.findIndex((e) => e.CompanyGuid === guid);
    }

    getSearchedCompanies(companies, searchOptions){
        if(!companies){
            return [];
        }

        if(!searchOptions){
            return companies;
        }

        let companiesToRender = companies;
        if(searchOptions){
            if(searchOptions.sortTag){
                // --> sort companies
                searchOptions.sortTag.function(companiesToRender);
                if(searchOptions.inverted){
                    companiesToRender.reverse();
                }
            }

            if(searchOptions.filterTag){
                // --> filter companies
                companiesToRender = searchOptions.filterTag.function(companiesToRender, searchOptions.filterTag.searchText);
            }
        }

        return companiesToRender;
    }

    getCompanyTable(companiesToRender){
      const { t } = this.props;
      if(!companiesToRender){
            return;
      }

      var elements = [];
      companiesToRender.map((elem, indx) =>(
          elements.push(
            <tr className='TableRow' key={indx}>
                <td title={elem.CompanyName}>{elem.CompanyName}</td>
                {this.state.editCompanyLimit !== indx &&
                  <td title={elem.ModelLimit} onClick={()=> this.setEditCompanyLimit(indx, elem.CompanyGuid)}><label>{elem.ModelLimit}</label></td>
                }
                {this.state.editCompanyLimit === indx &&
                  <td title={this.state.tempModelLimit}>
                    <input
                      type="text"
                      autoFocus
                      onKeyDown={(e) => {if(e.code === "Enter")this.setEditCompanyLimit(-1, elem.CompanyGuid, this.state.tempModelLimit)}}
                      onBlur={() => this.setEditCompanyLimit(-1, elem.CompanyGuid, this.state.tempModelLimit)}
                      value={this.state.tempModelLimit}
                      onChange={(e) => this.setState({tempModelLimit: e.target.value})}
                    />
                  </td>
                }
                {this.state.editCompanyUserLimit !== indx &&
                  <td onClick={()=> this.setEditCompanyUserLimit(indx, elem.CompanyGuid)} title={elem.UserLimit}>
                    <label>{elem.UserLimit ? elem.UserLimit : "?"}</label>
                  </td>
                }
                {this.state.editCompanyUserLimit === indx &&
                  <td title={this.state.tempUserLimit}>
                    <input
                      type="text"
                      autoFocus
                      onKeyDown={(e) => {if(e.code === "Enter")this.setEditCompanyUserLimit(-1, elem.CompanyGuid, this.state.tempUserLimit)}}
                      onBlur={() => this.setEditCompanyUserLimit(-1, elem.CompanyGuid, this.state.tempUserLimit)}
                      value={this.state.tempUserLimit}
                      onChange={(e) => this.setState({tempUserLimit: e.target.value})}
                      />
                  </td>
                }
                <td title='App'>
                  <label className="switch">
                      <input onChange={(e) => this.updateAppAccess(elem.CompanyGuid, e.target.checked)} checked={elem["AppAccess"]} type="checkbox"></input>
                      <span className="slider round"></span>
                  </label>
                </td>
                <td title='Rapid'>
                  <label className="switch">
                      <input onChange={(e) => this.updateRapidAccess(elem.CompanyGuid, e.target.checked)} checked={elem["PipelineType"]} type="checkbox"></input>
                      <span className="slider round"></span>
                  </label>
                </td>
                <td title='TFA'>
                  <label className="switch">
                      <input onChange={(e) => this.updateCompanyTfaPolicy(elem.CompanyGuid, e.target.checked)} checked={elem["TFA"]} type="checkbox"></input>
                      <span className="slider round"></span>
                  </label>
                </td>
              <td>
                <button
                  title={t('RemCompany')}
                  className="armodelviewer_button"
                  onClick={() => this.remCompany(elem.CompanyGuid)}>
                    <img alt="" src={BinIcon}/>
                </button>
              </td>
            </tr>)
        ));

        return elements;
    }

    updateAppAccess(companyId, newAccess){
      var newCompanies = this.state.companies;
      var company = newCompanies.find((e) => e.CompanyGuid === companyId);
      var prevAccess = company["AppAccess"];
      company["AppAccess"] = newAccess;
      this.setState({companies: newCompanies});
      AdminHandler.updateCompanyAppAccess(companyId, newAccess)
      .then((res) => {})
      .catch((err) =>{
        console.error(err);
        company["AppAccess"] = prevAccess;
        this.setState({companies: newCompanies});
      })
    }

    updateRapidAccess(companyId, newAccess){
      var newCompanies = this.state.companies;
      var company = newCompanies.find((e) => e.CompanyGuid === companyId);
      var prevAccess = company["PipelineType"];
      company["PipelineType"] = newAccess;
      this.setState({companies: newCompanies});
      AdminHandler.updateCompanyRapidAccess(companyId, newAccess)
      .then((res) => {})
      .catch((err) =>{
        console.error(err);
        company["PipelineType"] = prevAccess;
        this.setState({companies: newCompanies});
      })
    }

    updateCompanyTfaPolicy(companyId, newPolicy)
    {
      const { t } = this.props;
      var newCompanies = this.state.companies;
      var tfaCompany = newCompanies.find((e) => e.CompanyGuid === companyId);
      var prevTfaPolicy = tfaCompany["TFA"];
      tfaCompany["TFA"] = newPolicy;
      Dialog.Alert({
          title: t('TFADangerHeader'),
          description: t('TFADangerBody', { '0': newCompanies.find((e) => e.CompanyGuid === companyId)["CompanyName"] }),
          options: [
              {label: t('OK'), className:"dangerConfirm"},
              {label: t('Cancel'), className:""},
          ],
          panelOptions: {className: "vithrough"},
      }).then((optionChosen) => {
          if (optionChosen === 0) {
            tfaCompany["TFA"] = newPolicy;
            this.setState({companies: newCompanies});
            AdminHandler.updateCompanyTFAPolicy(companyId, newPolicy)
              .then((res) => {})
              .catch((err) =>{
                console.error(err);
                tfaCompany["TFA"] = prevTfaPolicy;
                this.setState({companies: newCompanies});
              })
          }
      })
    }

    resetInputFields(){
      this.setState({addingCompany: false, tempCompanyName: "", tempCompanyLimit: 0, tempUserLimit: 0, tempRapid: false, tempAppAccess: false});
    }

    remCompany(guid){
        const { t } = this.props;
        const self = this;
        var companyName = this.state.companies.filter(company => company.CompanyGuid === guid)[0].CompanyName;
        Dialog.Alert({
            title: t('RemCompany') + " " + companyName,
            description: t('RemCompanySure'),
            options: [
                {label: t('Delete'), className:"dangerConfirm"},
                {label: t('Cancel'), className:""},
            ],
            panelOptions: {className: "vithrough"}
            }).then((optionChosen) => {
            if (optionChosen === 0) {
                AdminHandler.remCompany("userid", guid)
                .then((res) => {
                  self.setState({addingCompany: false});
                  self.getCompanies();
                })
                .catch((err) =>{
                  console.error(err);
                })
            }
        });
    }

    addCompany(){
      const self = this;
      const st = this.state;
      console.log("im here");
      AdminHandler.addCompany("userid", st.tempCompanyName, st.tempCompanyLimit, st.tempUserLimit, st.tempAppAccess, st.tempRapid).then((res) => {
        console.log("im here2");
        self.resetInputFields();
        self.getCompanies();
      })
      .catch((err) =>{
        console.log("addCompany rejected:", err);
      })
    }

    getPageAmount(elements){
        if(!elements || elements.length === 0){
            return 0;
        }

        return Math.ceil(elements.length / this.state.maxCompaniesPerPage);
    }

    setCompaniesToRender(companiesToSearch, searchOptions, pageIndex){
        let searchedCompanies = this.getSearchedCompanies(companiesToSearch, searchOptions);
        let pageAmount = this.getPageAmount(searchedCompanies);
        let companiesOnPage = searchedCompanies.slice(pageIndex * this.state.maxCompaniesPerPage, (pageIndex + 1) * this.state.maxCompaniesPerPage);
        this.setState({
            companiesSearchOptions: searchOptions,
            searchedCompanies: searchedCompanies,
            companyPageIndex: pageIndex,
            companyPagesAmount: pageAmount,
            companiesToRender: companiesOnPage,
        })
    }

    render() {
      const { t } = this.props;
      const state = this.state;
      const companiesSortTags = this.getCompaniesSortTags();
        const showFooter = state.searchedCompanies?.length > state.maxCompaniesPerPage;
      return (
        <div className='user_files_container'>
            <div className={state.headerOpen ? 'user_files_list_header open' : 'user_files_list_header'}
              onPointerUp={(e) => {
                callIfPointerSupported(() => this.setState({open: !state.open, headerOpen: !state.open === true ? true : state.headerOpen}), e);
                e.stopPropagation();
                e.preventDefault();
              }}
              onTouchStart={(e) => {
                callIfTouchSupported(() => this.setState({open: !state.open, headerOpen: !state.open === true ? true : state.headerOpen}));
                e.stopPropagation();
                e.preventDefault();
              }}
              onMouseUp={(e) => {callIfMouseSupported(() => this.setState({open: !state.open, headerOpen: !state.open === true ? true : state.headerOpen}), e);
                e.stopPropagation();
                e.preventDefault();
              }}
            >
                <div className='user_files_list_header_left'>
                <div id='user_list_circle' className='user_list_circle'/>
                  <label id='Models'>{t('Companies')}</label>
                </div>
            </div>
            <div
              className={'user_files_list_container' + (state.open ? '_open' : '_hidden') + (showFooter ? '' : ' no_footer')}
              onTransitionEnd={() => {
                if(!state.open){
                  this.setState({headerOpen: false});
                }
              }}
            >
              <div className='user_files_list_container_inner'>
              <SearchBar
                onNewSearchOptions={(options) => {
                  this.setCompaniesToRender(state.companies, options, 0);
                }}
                sortTags={companiesSortTags}
                filterTags={[
                    {title: t('FilterTagName'),
                    function:
                        function(elements, filterText){
                        return elements.filter((elem) => {
                            if(filterText == null || filterText === ""){
                              return true; //if there is nothing to filter against
                            }
                            return elem && elem.CompanyName && filterText && elem.CompanyName.toLowerCase().indexOf(filterText.toLowerCase()) >= 0;
                        })
                    }},
                ]}
              />
              <div className='user_files_list'>
                <table className='company_table'>
                  <colgroup>
                      <col className='first-col'/>
                      <col className='second-col'/>
                      <col className='third-col'/>
                      <col className='forth-col'/>
                      <col className='fifth-col'/>
                      <col className='sixth-col'/>
                      <col className='seventh-col'/>
                  </colgroup>
                  <thead>
                    <tr>
                      <th>
                        Name
                      </th>
                      <th>
                        {t('CompaniesModelLimit')}
                      </th>
                      <th >
                        {t('CompaniesCoworkersLimit')}
                      </th>
                      <th>
                        App
                      </th>
                      <th>
                        Rapid
                      </th>
                      <th>
                        2FA
                      </th>
                      <th>
                        {!state.addingCompany &&
                          <button
                            className="armodelviewer_button"
                            title={t('AddCompany')}
                            onClick={() => this.setState({addingCompany: true})}
                          >
                            <img alt="" src={PlusIcon}/>
                          </button>
                        }
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {state.addingCompany &&
                      <tr>
                        <td>
                          <input
                            type='text'
                            tempCompanyLimit
                            value={state.tempCompanyName}
                            onChange={(e) => this.setState({tempCompanyName: e.target.value})}/>
                        </td>
                        <td>
                          <input
                            type='text'
                            pattern="[1-9]{1}[0-9]{3}"
                            value={state.tempCompanyLimit}
                            onChange={(e) => this.setState({tempCompanyLimit: e.target.value})}/>
                        </td>
                        <td>
                          <input
                            type='text'
                            pattern="[1-9]{1}[0-9]{3}"
                            value={state.tempUserLimit}
                            onChange={(e) => this.setState({tempUserLimit: e.target.value})}/>
                        </td>
                        <td>
                          <label className="switch">
                            <input type="checkbox" onChange={(e) => this.setState({tempAppAccess : e.target.value})}></input>
                            <span className="slider round"></span>
                          </label>
                        </td>
                        <td>
                          <label className="switch">
                            <input type="checkbox" onChange={(e) => this.setState({tempRapid : e.target.value})}></input>
                            <span className="slider round"></span>
                          </label>
                        </td>
                        <td>
                          <label className="switch">
                            <input type="checkbox" onChange={(e) => this.setState({tempTFA : e.target.value})}></input>
                            <span className="slider round"></span>
                          </label>
                        </td>
                        <td>
                          <div className='table_buttons_container'>
                            <button
                              onClick={() => this.addCompany()}
                              className="armodelviewer_button"
                              title={t('AddCompany')}
                            >
                              <img
                                alt=""
                                src={Checkmark}
                              />
                            </button>
                            <button
                              title={t('Cancel')}
                              onClick={() => this.resetInputFields()}
                              className="armodelviewer_button"
                            >
                              <img
                                alt=""
                                className='img_rotate_45'
                                src={PlusIcon}
                              />
                            </button>
                          </div>
                        </td>
                      </tr>
                    }
                    {this.getCompanyTable(state.companiesToRender)}
                  </tbody>
                </table>
            </div>
            {showFooter &&
              <div className='user_files_list_footer'>
                  <span className='border_span'/>
                  <Pagination
                      pageIndex={state.companyPageIndex}
                      pageAmount={state.companyPagesAmount}
                      onClickPageLink={(pageIndex) =>{
                        this.setCompaniesToRender(state.companies, state.companiesSearchOptions, pageIndex);
                      }}
                  />
              </div>
            }
              </div>
            </div>
        </div>);
    }
}

export default withTranslation()(CompanyList);
